import React from "react";
import PlanOverride from "../../../pages/LookUps/PlanOverride/PlanOverride";
import BenefitMaxSchedule from "../../../pages/BenefitMaxSchedule/BenefitMaxSchedule";
import AccumulationCodeList from "../../../pages/AccumulationCodeList/AccumulationCodeList";
import BenefitMaxDrugStatusSchedule from "../../../pages/BenefitMaxDrugStatusSchedule/BenefitMaxDrugStatusSchedule";
import ThirdPartyException from "../../../pages/LookUps/ThirdPartyException/ThirdPartyException";
import RouteOfAdministration from "../../../pages/LookUps/RouteOfAdmin/RouteOfAdministration";
import RouteOfAdministrationList from "../../../pages/LookUps/RouteOfAdminList/RouteOfAdministrationList";
import DosageForm from "../../../pages/LookUps/DosageForm/DosageForm";
import DosageFormList from "../../../pages/LookUps/DosageFormList/DosageFormList";
import PackagingCodesList from "../../../pages/LookUps/PackagingCodesList/PackagingCodesList";
import DeaClassList from "../../../pages/LookUps/DeaClassList/DeaClassList";
import NdcList from "../../../pages/LookUps/NdcList/NdcList";
import GpiMscList from "../../../pages/LookUps/GpiMscList/GpiMscList";
import CsrFederalLevel from "../../../pages/LookUps/CsrFederalLevel/CsrFederalLevel";
import TrOOPSchedule from "../../../pages/TroopSchedule/TrOOPSchedule";
import SelectMessage from "../../../pages/LookUps/SelectMessage/SelectMessage";
import AccumulationCode from "../../../pages/Accumalation/AccumulationCode";
import AccumulationCodeForm from "../../../pages/Accumalation/AccumulationCodeForm";
import AccumulationCodeListForm from "../../../pages/AccumulationCodeList/AccumulationCodeListForm";
import { PRICE_SCHEDULE_MODES } from "../../utils/Constants";
import TroopScheduleForm from "../../../pages/TroopSchedule/TrOOPScheduleForm";
import TroopScheduleStep from "../../../pages/TroopSchedule/TroopScheduleStep";
import CsrStateLevel from "../../../pages/LookUps/CsrStateLevel/CsrStateLevel";
import DrugStatusSchedule from "../../../pages/BenefitMaxDrugStatusSchedule/DrugStatusSchedule";
import AccumulationCodeListAl2 from "../../../pages/AccumulationCodeList/AccumulationCodeListAl2";
import AdjustmentReasonCode from "../../../pages/AdjustmentReasonCodes/AdjustmentReasonCode";

const LocalLookup = ({
  screenNumber,
  params,
  receiveData,
  hideModal,
  readOnly,
  sourceData,
  onNavigate,
}) => {
  const { default: lookupScreen } = screenNumber;
  const { lookupType, fieldMapping } = params;

  const selectParams = fieldMapping["default"];
  const paramsData = selectParams.reduce((acc, item) => {
    if (item["paramDataKey"]) {
      acc[item["paramDataKey"]] = sourceData[item["source"]];
    } else {
      acc[item["target"]] = sourceData[item["source"]];
    }
    return acc;
  }, {});

  switch (lookupScreen) {
    case "RCPLN018":
      return (
        <PlanOverride
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          paramsData={paramsData}
        />
      );
    case "RCBSC005":
      return (
        <BenefitMaxSchedule
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          onNavigate={onNavigate}
        />
      );
    case "RCBMD005":
      if (readOnly) {
        return null;
      }
      return (
        <BenefitMaxDrugStatusSchedule
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          displayMode={true}
          selectModeParamData={paramsData}
        />
      );
    case "RCAL1005":
      if (readOnly) {
        return (
          <AccumulationCodeListAl2
            selectMode={true}
            selectedCode={[paramsData]}
            hideModal={hideModal}
            lookupType={lookupType}
          />
        );
      }
      return (
        <AccumulationCodeList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectModeParamData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RC3EX900":
      return (
        <ThirdPartyException
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCRAD900":
      return (
        <RouteOfAdministration
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCRAL004":
      return (
        <RouteOfAdministrationList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCDF1001":
      return (
        <DosageForm
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCDFL005":
      return (
        <DosageFormList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCPKL005":
      return (
        <PackagingCodesList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCDCL005":
      return (
        <DeaClassList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCND1004":
      return (
        <NdcList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCGP3004":
      return (
        <GpiMscList
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCFCH004":
      return (
        <CsrFederalLevel
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCSCS004":
      return (
        <CsrStateLevel
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectModeParamData={paramsData}
        />
      );
    case "RCTSC003":
      if (readOnly) {
        return (
          <TroopScheduleStep
            selectMode={true}
            selectModeParamData={paramsData}
            hideModal={hideModal}
          />
        );
      }
      return (
        <TrOOPSchedule
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectModeParamData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RCMSG002":
      return (
        <SelectMessage
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectMode={true}
          selectModeParamData={paramsData}
        />
      );
    case "RCACM001":
      if (readOnly) {
        return (
          <AccumulationCodeForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
            selectMode={true}
            selectedSchedule={[paramsData]}
            hideModal={hideModal}
          />
        );
      }
      return (
        <AccumulationCode
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectMode={true}
          selectModeParamData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RCBDD001":
      return (
        <DrugStatusSchedule
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
          selectMode={true}
          selectedSchedule={[paramsData]}
        />
      );
    case "AdjustmentReasonCode":
      return (
        <AdjustmentReasonCode
          params={fieldMapping.default}
          lookupType={lookupType}
          selectMode={true}
          onSelect={receiveData}
          hideModal={hideModal}
          onNavigate={onNavigate}
        />
      );
    default:
      return null;
  }
};
export default LocalLookup;